import { useQuery, gql, useLazyQuery } from '@apollo/client';
import { ProjetosPageQuery, ProjetosPageQueryVariables } from './__generated__/ProjetosPageQuery';

const PROJETOS_QUERY = gql`
  query ProjetosPageQuery($descricao: String, $pagina: Int, $itens_por_pagina: Int) {
    projetos_pedagogicos(
      filter: { descricao: $descricao, pagina: $pagina, itens_por_pagina: $itens_por_pagina }
    ) {
      id_projeto_pedagogico
      id_oferta
      id_disciplina
      id_professor
      ind_semestre
      ind_ordem
      num_carga_horaria_to
      dsc_modalidade
      ind_modalidade
      dsc_sigla_disciplina
      disciplina {
        id_disciplina
        dsc_nome_disciplina
        dsc_sigla
        num_carga_horaria
      }
      professor {
        id_professor
        dsc_nome_professor
      }
      oferta {
        id_oferta
        id_curso
        num_oferta
        num_ano
        num_semestre
      }
    }
  }
`;

const useProjetosPageQuery = (variables: ProjetosPageQueryVariables) => {
  return useQuery<ProjetosPageQuery, ProjetosPageQueryVariables>(PROJETOS_QUERY, {
    variables,
  });
};

const useProjetosLazyQuery = () => {
  return useLazyQuery<ProjetosPageQuery, ProjetosPageQueryVariables>(PROJETOS_QUERY);
};

export { useProjetosPageQuery, useProjetosLazyQuery };
